export default __webpack_public_path__ + "static/media/landing.04cccd38.mp4";